import * as React from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { useCustomTimeRange } from 'modules/attendance/hooks/useCustomTimeRange'
import { CustomTimeRangesCollection } from 'modules/attendance/hooks/useFetchCustomTimeRanges'

import Cell from './Cell'

export interface Props {
  timeRanges: CustomTimeRangesCollection
  settingId: number
}

const TableContent = ({ timeRanges, settingId }: Props) => {
  const { dayEnums } = useCustomTimeRange()

  return (
    <Table.Body>
      <Table.Row background="grey100">
        <Table.Cell noBorder>
          <Box
            height="full"
            minHeight="s80"
            paddingLeft="s4"
            paddingTop="s16"
            paddingBottom="s40"
            width="s120"
          >
            <Text size="100" weight="semibold" ellipsis>
              {i18n
                .t('time_tracking.settings.custom_time_range_section.full_day_title')
                .toUpperCase()}
            </Text>
          </Box>
        </Table.Cell>
        {dayEnums.map((day) => {
          return (
            <Table.Cell key={`full_${day}`} noBorder>
              <Cell
                timeRanges={timeRanges.rangesInSpecificBaseDay(day)}
                dayType={day}
                base
                showNotDefined={
                  !timeRanges.hasRangesInSpecificBaseDay(day) &&
                  !timeRanges.hasRangesInSpecificCustomDay(day)
                }
                settingId={settingId}
              />
            </Table.Cell>
          )
        })}
      </Table.Row>
      <Table.Row background="grey100">
        <Table.Cell noBorder verticalAlign="top">
          <Box minHeight="s80" height="full" paddingLeft="s4" width="s120">
            <Text size="100" weight="semibold" ellipsis>
              {i18n
                .t('time_tracking.settings.custom_time_range_section.except_title')
                .toUpperCase()}
            </Text>
          </Box>
        </Table.Cell>
        {dayEnums.map((day) => (
          <Table.Cell key={`exception_${day}`} noBorder verticalAlign="top">
            <Cell
              timeRanges={timeRanges.rangesInSpecificCustomDay(day)}
              dayType={day}
              showNotDefined={false}
              settingId={settingId}
            />
          </Table.Cell>
        ))}
      </Table.Row>
    </Table.Body>
  )
}
export default TableContent
